import { useContext, useEffect, useState } from 'react';

import { IoMdClose } from 'react-icons/io';

import { BoletoView } from '../ViewsMenu/BoletoView';
import { CreditCardView } from '../ViewsMenu/CreditCardView';
import { PixView } from '../ViewsMenu/PixView';

import styles from './PurchaseMenu.module.scss';
import { CheckoutContext } from '@/context/Checkout';
import { showToast } from '@/components/atoms/Toast/Toast';
import { axiosInstance } from '@/utils/axiosInstance';
import { navigate } from '@/utils/navigate';
import { Loading } from '@/components/atoms';
import { useRouter } from 'next/router';

let showAppButton: boolean;

export const PurchaseMenu = ({
  appButton,
  origin,
  paymentCards,
  isCreditCardMpActive = false,
  isPixMpActive = false,
  userState = '',
  isPagaLeveActive,
  userInfo,
  changePagarmeToPagaleve,
  newDesign,
  isIuguActive,
  isStarkBankActive,
  isPagzoopActive,
  gamificationInfo,
  setGamificationData,
}) => {
  const router = useRouter();

  const { checkoutData } = useContext(CheckoutContext);
  const activeBundle = checkoutData.bundlesData.find(
    (bundle) => bundle.nameId === checkoutData.currentBundleName
  );

  const [currentOption, setCurrenteOption] = useState('card');
  const [loading, setLoading] = useState<boolean>(false);
  const [pagaleveWebviewUrl, setPagaleveWebviewUrl] = useState<string | null>(
    null
  );

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'PAGALEVE_PAYMENT_SUCCESS') {
        setPagaleveWebviewUrl(null);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const viewOption = {
    pix: (
      <PixView
        appButton={appButton}
        origin={origin}
        userState={userState}
        isIuguActive={isIuguActive}
        userInfo={userInfo}
        isStarkBankActive={isStarkBankActive}
        isPagzoopActive={isPagzoopActive}
        gamificationInfo={gamificationInfo}
        setGamificationData={setGamificationData}
      />
    ),
    card: (
      <CreditCardView
        appButton={appButton}
        origin={origin}
        paymentCards={paymentCards}
        userState={userState}
        isIuguActive={isIuguActive}
        userInfo={userInfo}
        isStarkBankActive={isStarkBankActive}
        isPagzoopActive={isPagzoopActive}
        isPagaLeveActive={isPagaLeveActive}
        onRedirectToPixInstallments={() => handleRedirectPagaleve(false)}
        gamificationInfo={gamificationInfo}
        setGamificationData={setGamificationData}
      />
    ),
    boleto: (
      <BoletoView
        origin={origin}
        userState={userState}
        isIuguActive={isIuguActive}
      />
    ),
    pixPagaleve: loading && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 200,
        }}
      >
        <Loading />
      </div>
    ),
    pagaleve: loading && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 200,
        }}
      >
        <Loading />
      </div>
    ),
  };

  const handleRedirectPagaleve = async (is_pix_upfront: boolean) => {
    const option = is_pix_upfront ? 'pixPagaleve' : 'pagaleve';

    setCurrenteOption(option);
    setLoading(true);
    try {
      const url = router.asPath;

      const callback_cancel_url = `https://www.getninjas.com.br${url}`;
      const callback_approve_url = `https://www.getninjas.com.br/seja-um-profissional/pagaleve-sucesso`;

      const requestOptions = {
        method: 'POST',
        url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/pix_pagaleve`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userInfo,
          activeBundle,
          callback_approve_url,
          callback_cancel_url,
          is_pix_upfront,
        },
      };

      const { data } = await axiosInstance(requestOptions);

      if (window?.newrelic) {
        window.newrelic.addPageAction('webcheckout_action', {
          step: 'pix_pagaleve_click',
          origin: origin,
        });
      }

      setLoading(false);
      if (origin === 'webcheckout-ios') {
        setPagaleveWebviewUrl(data.checkoutUrl);

        return;
      }

      navigate(data.checkoutUrl);
    } catch (error) {
      if (window?.newrelic) {
        window.newrelic.addPageAction('webcheckout_action', {
          step: 'pix_pagaleve_error',
          origin: origin,
        });
      }

      setLoading(false);
      setCurrenteOption('card');
      showToast({
        message: error.response.data.clientMessage,
        type: 'error',
      });
    }
  };

  const pixUpFront = () => {
    if (changePagarmeToPagaleve) {
      return (
        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'pixPagaleve' ? styles.active : ''
          } `}
          onClick={() => handleRedirectPagaleve(true)}
        >
          <p>Pix</p>
          <span>à vista</span>
        </button>
      );
    }

    return (
      <button
        className={`menu__item ${styles['menu__item']} ${
          currentOption === 'pix' ? styles.active : ''
        } `}
        onClick={() => setCurrenteOption('pix')}
      >
        <p>Pix</p>
        <span>à vista</span>
      </button>
    );
  };

  const newDesignPagaleve = () => {
    if (isPagaLeveActive) {
      return (
        <>
          {pixUpFront()}

          <button
            className={`menu__item ${styles['menu__item']} ${
              currentOption === 'pagaleve' ? styles.active : ''
            } `}
            onClick={() => handleRedirectPagaleve(false)}
          >
            <p>Pix</p>
            <span>parcelado</span>
          </button>
        </>
      );
    }

    return (
      <button
        className={`menu__item ${styles['menu__item']} ${
          currentOption === 'pix' ? styles.active : ''
        } `}
        onClick={() => setCurrenteOption('pix')}
      >
        <p>Pix</p>
        <span>à vista</span>
      </button>
    );
  };

  return (
    <>
      {pagaleveWebviewUrl && (
        <div className={styles['pagaleve__webview__overlay']}>
          <iframe
            src={pagaleveWebviewUrl}
            className={styles['pagaleve__webview__iframe']}
            title="Pagaleve"
          />
        </div>
      )}
      <div className={`purchase__menu ${styles['purchase__menu']}`}>
        <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'card' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('card')}
        >
          <p>Cartão</p>
          <span>Até 3x</span>
        </button>

        {newDesignPagaleve()}

        {/* <button
          className={`menu__item ${styles['menu__item']} ${
            currentOption === 'boleto' ? styles.active : ''
          } `}
          onClick={() => setCurrenteOption('boleto')}
        >
          <p>Boleto</p>
          <span>à vista</span>
        </button> */}
      </div>
      <div
        className={`purchase__option__view ${styles['purchase__option__view']}`}
      >
        {viewOption[currentOption]}
      </div>
    </>
  );
};
